import api from '../config/api';

const configuracionContratosService = {
  async obtenerConfiguracion(empresaId) {
    try {
      const response = await api.get(`/configuracion-contratos/empresa/${empresaId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al obtener configuración de contratos'
      };
    }
  },

  async actualizarConfiguracion(empresaId, activo) {
    try {
      const response = await api.put(`/configuracion-contratos/empresa/${empresaId}`, { activo });
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      if (error.response?.status === 422) {
        return {
          success: false,
          error: 'Datos de entrada inválidos',
          details: error.response.data.details
        };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al actualizar configuración de contratos'
      };
    }
  },

  async verificarEstado(empresaId) {
    try {
      const response = await api.get(`/configuracion-contratos/empresa/${empresaId}/estado`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al verificar estado de contratos'
      };
    }
  }
};

export default configuracionContratosService;
